import React from "react";

import { Tag } from "antd";
import { BaseTagProps } from "./types";

import "./styles.css";

const BaseTag = ({
  label,
  className,
  size = "large",
  icon,
  hasRoundCorners = false,
  thumbnail,
  style,
  ...props
}: BaseTagProps) => {
  const onPreventMouseDown = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const tagClassName = [
    "base-tag",
    `base-tag-${size}`,
    className ? `${className}-tag` : "",
    hasRoundCorners ? "round-tag" : "",
    thumbnail?.src ? "base-tag--has-thumbnail" : "",
    size === "extra-small" ? "body-xs-regular" : "body-s-regular",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <Tag
      onMouseDown={onPreventMouseDown}
      className={tagClassName}
      style={style}
      icon={icon}
      {...props}
    >
      {thumbnail?.src ? (
        <>
          <span className="base-tag__thumbnail">
            <img
              src={thumbnail?.src}
              alt={thumbnail?.alt || ""}
              loading="lazy"
            />
          </span>

          <span className="base-tag__label">{label}</span>
        </>
      ) : (
        label
      )}
    </Tag>
  );
};

export default BaseTag;
